import { gql } from "@apollo/client";

export const GET_ALL_PACKAGE_ORDERS = gql`
  query getAllPackageOrders(
    $where: package_order_bool_exp
    $limit: Int
    $offset: Int
  ) {
    packages {
      id
      name
      chinese_name
      package_country {
        id
        name
      }
    }
    package_order_aggregate(where: $where, order_by: { created_at: desc }) {
      aggregate {
        count(columns: id)
      }
    }
    package_order(order_by: { created_at: desc }) {
      id
      quantity
      system_offer
      selling_price
      created_at
      approved_at
      payment_slip
      status
      package_id
      month
      year
      user {
        id
        name
        avatar
        username
      }
      seller {
        id
        name
        username
        avatar
      }
      order_package {
        id
        name
        chinese_name
        package_country {
          id
          name
        }
      }
    }
    allResults: package_order(where: $where, order_by: { id: asc }) {
      id
      quantity
      system_offer
      selling_price
      created_at
      approved_at
      payment_slip
      package_id
      status
      month
      year
      user {
        id
        name
        avatar
        username
      }
      seller {
        id
        name
        username
        avatar
      }
      order_package {
        id
        name
        chinese_name
        package_country {
          id
          name
        }
      }
    }
    paginated: package_order(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { id: desc }
    ) {
      id
      quantity
      system_offer
      selling_price
      created_at
      package_id
      approved_at
      payment_slip
      status
      month
      year

      user {
        id
        name
        avatar
        username
      }
      seller {
        id
        name
        username
        avatar
      }
      order_package {
        id
        name
        chinese_name
        package_country {
          id
          name
        }
      }
    }
  }
`;
